import{combineReducers} from 'redux';
import{appReducers} from './dashboardReducers';
const reducers=combineReducers({
    App:appReducers,
}) 
export default reducers;